import { triggerStateChangedRequest } from './triggerStateChangedRequest';

export const editorFlipVertical = () => {
  const selection = window.canvas && window.canvas.getActiveObject();
  if (!selection) throw new Error('No objects selected');

  let target = selection;
  try {
    if (selection.type === 'MagicFrame' && selection.editingImg) {
      target = selection.editingImg;
    }
  } catch (e) {
    console.error('Failed to map selection to editing image (flipY)', e);
  }

  target.set({ flipY: !target.flipY });
  window.canvas && window.canvas.renderAll();
  try {
    triggerStateChangedRequest();
  } catch (e) {
    console.error('Failed to trigger state change after flipY', e);
  }
};
